"use client";

import React from "react";
import { Carousel } from "@components/molecules/Carousel";
import { AllFeatureCard } from "@components/molecules/AllFeatureCard";
import styles from "./AllFeaturesCarousel.module.scss";
import { AllFeaturesCarouselProps } from "./AllFeaturesCarousel.types";

export const AllFeaturesCarousel: React.FC<AllFeaturesCarouselProps> = ({
  className = "",
  modelFeatures,
  isSellable,
  isMMV
}) => {
  // Flatten all features from all categories into a single array
  const allFeatures = modelFeatures.flatMap(category => category.features);

  // If no features or categories, don't render
  if (!modelFeatures || modelFeatures.length === 0) {
    return null;
  }

  return (
    <section className={`${styles.allFeaturesCarousel} ${className}`}>
      {/* Bottom Section - Detailed Features */}
      <div className={styles.bottomSection}>

        <div className={styles.detailedCarousel}>
          <Carousel heading="Key Features" headingClassName={styles.carouselHeading} arrowButtonClass={styles.arrowButton} isDark className={styles.detailedCarouselContainer} showMobileDots={true}>
            {allFeatures.map((feature) => {
              // Transform feature data for AllFeatureCard
              const transformedFeature = {
                id: feature.id.toString(),
                title: feature.displayName || feature.name,
                description: feature.additionalInfo?.feature_value?.value
                  ? `${feature.additionalInfo.feature_value.value}${
                      feature.additionalInfo.feature_value.unit
                        ? ` ${feature.additionalInfo.feature_value.unit}`
                        : ""
                    }`
                  : feature.description || "",
                image:
                  feature.media && feature.media.length > 0
                    ? feature.media[0].url
                    : "",
                availableVariants:
                  feature.availableVariants &&
                  feature.availableVariants.length > 0
                    ? `Available in ${
                        feature.availableVariants.length
                      } variant${
                        feature.availableVariants.length > 1 ? "s" : ""
                      }`
                    : "",
                available: feature.availableVariants,
                category: feature.category,
              };

              return (
                <AllFeatureCard
                  key={feature.id}
                  feature={transformedFeature}
                  isDetailed={true}
                  isSellable={isSellable}
                  isMMV={isMMV}
                />
              );
            })}
          </Carousel>
        </div>

        {/* <Button className={styles.ctaButton}>
          <Text className={styles.ctaText}>{`Explore all features`}</Text>
        </Button> */}
      </div>
    </section>
  );
};
